import { Modal, ModalDialog, ModalClose, Typography, List, Stack, Divider } from "@mui/joy";

export default function SaldoDosItens(props) {
    console.log(props);
    return (
        <Modal
            open={props.openModalInfoItem}
            onClose={() => props.setOpenModalInfoItem(false)}
        >
            <ModalDialog
                aria-labelledby="variant-modal-title"
                aria-describedby="variant-modal-description"
                variant={"soft"}>
                <ModalClose />
                <Typography
                    id="basic-list-demo"
                    level="body-xs"
                    textTransform="uppercase"
                    fontWeight="lg"
                >
                    Saldos do Item 
                </Typography>
                <Typography sx={{ fontSize: 14, marginBottom: "10px", marginTop: "15px", backgroundColor: "#BBDEFB" }}>(saldo atualizado no dia de hoje)</Typography>
                <Stack backgroundColor="#dde2ed" padding={"10px"} mt="10px" borderRadius={"10px"}>
                    <Typography sx={{ fontSize: 14 }}>Código: {props.saldosDoItem && props.saldosDoItem[0]?.CODIGOPRD}</Typography>
                    <Typography sx={{ fontSize: 14 }}>Descrição: {props.saldosDoItem && props.saldosDoItem[0]?.NOMEFANTASIA}</Typography>
                </Stack>
                <List sx={{ marginTop: "10px" }} aria-labelledby="basic-list-demo">
                    {props.saldosDoItem.map(function (saldo, indice) {
                        return (
                            <Stack mb="10px" style={saldo.IGNORE ? { backgroundColor: "#fff9c483", borderRadius: "10px" } : {}} key={indice}>
                                <Typography fontSize={14}>{saldo.NOME}</Typography>
                                <Typography fontSize={14} fontWeight={"bold"} sx={{marginBottom: "5px"}} >Saldo: {saldo.SALDOFISICO2}</Typography>
                                {saldo.IGNORE && <Typography sx={{color: "#333"}} fontSize={12}>Obs: Local de estoque da requisição</Typography>}
                                {((props.saldosDoItem.length - 1) > indice) ?
                                    <Divider />
                                    : null}
                            </Stack>
                        )
                    })}
                </List>
            </ModalDialog>
        </Modal>
    );
}